import { ResetPassword } from '@unistocks/features/authentication/reset-password';
import { t } from '@unistocks/shared/localization/index.ts';
import { useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';

export default function ResetPasswordScreen() {
  const { tenantId, userId, resetToken } = useLocalSearchParams<{
    tenantId?: string;
    userId: string;
    resetToken: string;
  }>();

  return (
    <>
      <Head>
        <title>{`${t('AbpAccount::PasswordReset')} | Unistocks`}</title>
      </Head>
      <ResetPassword tenantId={tenantId} userId={userId} resetToken={resetToken} />
    </>
  );
}
